import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { StorageKeysEnum } from 'app/enums';
import { RoutesEnum, RoutingService } from '../';
import { FeatureToggle } from '@Enums';
import { AuthLegacyService } from '../../auth/auth-legacy.service';
import { FeatureManagerService } from '../global/feature-manager/feature-manager.service';
import { PurlService } from '../purl.service';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(
    public authService: AuthLegacyService,
    public auth0Service: AuthService,
    public routingService: RoutingService,
    public featureManagerService: FeatureManagerService,
    public purlService: PurlService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

        return new Promise(async (resolve) => {
            let loggedIn = false;

            const libertySupplementalHealthEnabled = this.featureManagerService.getByName(FeatureToggle.CaseLibertySupplementalHealth).enabled;
            const intendedUrl = libertySupplementalHealthEnabled ? state.url : (globalThis.location.pathname + globalThis.location.search);

            if (this.useV2Auth()) {
                const purlUser = localStorage.getItem(StorageKeysEnum.PurlResult);
                if (purlUser){
                    resolve(await this.handleLoginV2(intendedUrl));
                }else {
                    this.auth0Service.isAuthenticated$.subscribe(async result => {
                        loggedIn = result || this.purlService.isPurlUser();
                        if (loggedIn) {
                            resolve(await this.handleLoginV2(intendedUrl));
                        } else {
                            const queryParams: any = {};

                            if (globalThis.location.search !== ''){
                                const params = new URLSearchParams(globalThis.location.search);

                                if (globalThis.location.search !== ''){
                                    localStorage.setItem('customAttributes', globalThis.location.search);
                                }

                                params.forEach(function(value, key) {
                                    queryParams[key] = value;
                                });
                            }

                            localStorage.setItem('uwpipeline.savedRedirectTo', intendedUrl);
                            
                            if(queryParams && queryParams !== null){
                                this.routingService.navigateToRoute(RoutesEnum.loginV2, null, queryParams);
                            } else {
                                this.routingService.navigateToRoute(RoutesEnum.loginV2);
                            }
                        }
                    });
                }
            } else {
                resolve(await this.handleLegacyLogin(intendedUrl));
            }
        });
    }

    useV2Auth(){
        if (window.location.hash !== null && window.location.hash.indexOf('access_token') > 0) {
            localStorage.setItem('legacy', 'true');
            return false;
        }
        const legacy = JSON.parse(localStorage.getItem('legacy'));

        if ((legacy === false || legacy == null)) {
            return true;
        }

        return false;
    }

    async handleLegacyLogin(intendedUrl?: string): Promise<boolean> {
        let loggedIn = false;
        await this.authService.handleAuthentication(); // Parses the auth0 token if it exists.

        if (!this.authService.isAuthenticated()) {
            loggedIn = false;
        } else {
            loggedIn = await this.authService.loadAuthenticatedData();
        }

        if (!loggedIn) {
            // Store the intended URL for redirect after login
            const currentUrl = intendedUrl ?? (globalThis.location.pathname + globalThis.location.search);
            localStorage.setItem('uwpipeline.savedRedirectTo', currentUrl);
            
            this.authService.logout(); // clear old entries and nav to login
        }

        return Promise.resolve(loggedIn);
    }

    async handleLoginV2(intendedUrl?: string): Promise<boolean> {
        let loggedIn = false;

        loggedIn = await this.authService.loadAuthenticatedData();

        if (!loggedIn) {
            // Store the intended URL for redirect after login
            const currentUrl = intendedUrl ?? (globalThis.location.pathname + globalThis.location.search);
            localStorage.setItem('uwpipeline.savedRedirectTo', currentUrl);
            
            this.routingService.navigateToRoute(RoutesEnum.loginV2);
        }

        return Promise.resolve(loggedIn);
    }
}
